// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"SP-z","smallCardRow":"TP-z","largeCardRow":"UP-z","productSearchRow":"VP-z","curatedRow":"WP-z"};